import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CandidateTokenStorageService } from '../storage/candidate-token-storage.service';
import { normalizeStoredLanguage, readStoredLanguage } from '../i18n/language-storage';
import { CandidateTenantContextService } from '../tenant/candidate-tenant-context.service';

const AUTHORIZATION_EXCLUDED_ENDPOINTS = [
  '/candidate/Auth/register',
  '/candidate/Auth/login',
  '/candidate/Auth/refresh-token',
  '/candidate/Auth/forgot-password',
  '/candidate/Auth/reset-password',
];

export const handleRequestHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const tokens = inject(CandidateTokenStorageService);
  const tenantContext = inject(CandidateTenantContextService);
  const currentLang = normalizeStoredLanguage(readStoredLanguage() ?? 'en-US');
  const headers: Record<string, string> = {
    'Accept-Language': currentLang,
  };

  // Public job browsing sets its own tenant scope; everything else uses the resolved tenant.
  if (!req.headers.has('X-Tenant-Key')) {
    headers['X-Tenant-Key'] = tenantContext.getTenantKey();
  }

  if (!req.headers.has('Accept')) {
    headers['Accept'] = 'application/json';
  }

  if (!req.headers.has('Content-Type') && req.body && !(req.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const token = tokens.getAccessToken();
  if (token && !AUTHORIZATION_EXCLUDED_ENDPOINTS.some((endpoint) => req.url.includes(endpoint))) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return next(req.clone({ setHeaders: headers }));
};
